import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { UxAction, UxPriorityEnum, UxStyleEnum, UxModal } from "@imaginelearning/mps-ux-component-library";

interface ISessionModalProps {
  showModal: boolean;
  handleCancel: () => void;
  handleSetSession: () => void;
}

function SessionModal({ showModal, handleCancel, handleSetSession }: ISessionModalProps) {
  const { t } = useTranslation();
  const [isClickable, setIsClickable] = useState(true);
  useEffect(() => {
    if (!showModal) {
      setIsClickable(true);
    }
  }, [showModal]);
  return (
    <UxModal
      showModal={showModal}
      showClose={false}
      handleClose={handleCancel}
      title={t("User logged in")}
      backdrop="static"
      body={<span>{t("You are currently logged in elsewhere")}</span>}
      footer={[
        <UxAction
          key={1}
          enabled={true}
          text={t("Cancel")}
          priority={UxPriorityEnum.DANGER}
          callback={handleCancel}
          style={UxStyleEnum.ROUNDED}
          className="px-3"
        />,
        <UxAction
          key={0}
          enabled={true}
          text={t("Ok")}
          priority={UxPriorityEnum.SUCCESS}
          callback={() => {
            if (isClickable) {
              setIsClickable(false);
              handleSetSession();
            }
          }}
          style={UxStyleEnum.ROUNDED}
          className="px-3"
        />
      ]}
    />
  );
}

export default SessionModal;
